module.exports = __webpack_public_path__ + "img/antes_despues_176.d5008830.png";